import { render } from "./ElectionProcessModal.vue?vue&type=template&id=16d0e3c1&scoped=true"
import script from "./ElectionProcessModal.vue?vue&type=script&lang=js"
export * from "./ElectionProcessModal.vue?vue&type=script&lang=js"

import "./ElectionProcessModal.vue?vue&type=style&index=0&id=16d0e3c1&scoped=true&lang=css"

import exportComponent from "E:\\SLG\\ECO GAME\\Eco\\Server\\WebClient\\Sources\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16d0e3c1"]])

export default __exports__